import { queryClient } from 'App';

import { iaRa } from 'lib/helpers/utility';

export default async (data) => {
  const { appointment, invalidate } = data;
  if (invalidate) {
    queryClient.invalidateQueries({
      queryKey: ['appointment-events'],
      exact: false
    });
    return;
  }

  queryClient.setQueryData(['appointmentv2', appointment?.id], (oldData) => {
    if (!oldData) return;
    return {
      ...oldData,
      appointment: { ...(oldData?.appointment || {}), ...appointment }
    };
  });

  queryClient.setQueriesData({ queryKey: ['appointment-events'] }, (oldData) => {
    if (!oldData) return;
    return {
      ...oldData,
      appointment: iaRa(oldData.appointment).map((apt) =>
        apt?.id === appointment.id ? { ...apt, ...appointment } : apt
      )
    };
  });
};
